import { getBookingByNr, getBookingNr, } from "../../../../shared/functions/booking";
import OverviewTour from "../../../../shared/components/agentur/nav.intro.m";
import Tourmanager from "../../../../shared/functions/tours";
import Config from "../../../../config";
import User from "@phoenixreisen/user";
import m from "mithril";
const introName = "bookingchange";
export default class {
    oncreate() {
        if (!Tourmanager.hasDoneTour(introName)) {
            getBookingByNr(getBookingNr(User)).then(() => {
                setTimeout(() => {
                    try {
                        const tour = Tourmanager.Tour(OverviewTour);
                        tour.drive();
                        Tourmanager.markTourAsDone(introName);
                    }
                    catch {
                    }
                }, 1000);
            });
        }
    }
    view() {
        const { urls } = Config;
        return (m("article", { id: "agency-nav", class: "agency-nav" },
            m("div", { class: "agency-nav__headline" }, "Agentur"),
            m("ul", null,
                m("li", null,
                    m("a", { href: `${urls.LOGIN}#!/agentur/stellvertretung`, title: "f\u00FCr eine andere Buchung handeln" }, "Buchung wechseln")))));
    }
}
